import {
  BOOTSTRAP,
  BootstrapActionPayload,
  LOAD_MORE_ARTICLES_FULFILLED,
  LOAD_POPULAR_ARTICLES_FULFILLED,
  LoadMoreArticlesActionPayload,
  LoadPopularArticlesActionPayload,
  LOAD_MORE_ARTICLES_PENDING,
  LOAD_POPULAR_ARTICLES_PENDING,
} from './actions';
import { Collection, TitleBlock } from '../../../models/collection';
import { Brand } from '../../../lib/theme';
import createReducer from '../../../lib/createReducer';
import { ArticleBlockData } from '../CollectionBlock/Blocks/ArticleBlock';
import { MeetupBlockData } from '../CollectionBlock/Blocks/MeetupBlock';
import { ContentBlockData } from '../CollectionBlock/Blocks/ContentBlock';
import { HolidayBlockData } from '../CollectionBlock/Blocks/HolidayBlock';
import { PopularBlockData } from '../CollectionBlock/Blocks/PopularBlock';
import { HubBlockData } from '../CollectionBlock/Blocks/HubBlock';
import { PanelBlockData } from '../CollectionBlock/Blocks/PanelBlock';

export type Block =
  | ArticleBlockData
  | MeetupBlockData
  | ContentBlockData
  | HolidayBlockData
  | PopularBlockData
  | HubBlockData
  | PanelBlockData
  | TitleBlock;

export interface CollectionState extends Collection {
  brand: Brand;
  adConfig: {
    units: {
      [key: string]: string;
    };
  };
  blocks: Block[];
}

const initialState = {
  brand: 'sas',
  adConfig: {
    units: {},
  },
};

const handleBootstrap = (
  state: CollectionState,
  collection: BootstrapActionPayload
): CollectionState => ({
  ...state,
  ...collection,
});

const handleLoadMoreArticles = (
  state: CollectionState,
  { articles, moreArticlesURL, blockIndex }: LoadMoreArticlesActionPayload
): CollectionState => ({
  ...state,
  blocks: state.blocks.map((block, i) =>
    i === blockIndex &&
    (block.type === 'article_block' || block.type === 'hub_block')
      ? {
          ...block,
          articles: [...block.articles, ...articles],
          moreArticlesURL,
        }
      : block
  ),
  moreArticlesLoading: false,
});

const handleLoadPopularArticles = (
  state: CollectionState,
  payload: LoadPopularArticlesActionPayload
): CollectionState => ({
  ...state,
  popularArticles: payload,
  morePopularArticlesLoading: false,
});

const handleLoadingMoreArticles = (
  state: CollectionState
): CollectionState => ({
  ...state,
  moreArticlesLoading: true,
});

const handlePendingLoadPopularArticles = (
  state: CollectionState
): CollectionState => ({
  ...state,
  morePopularArticlesLoading: true,
});

const handlers = {
  [BOOTSTRAP]: handleBootstrap,
  [LOAD_MORE_ARTICLES_FULFILLED]: handleLoadMoreArticles,
  [LOAD_POPULAR_ARTICLES_FULFILLED]: handleLoadPopularArticles,
  [LOAD_MORE_ARTICLES_PENDING]: handleLoadingMoreArticles,
  [LOAD_POPULAR_ARTICLES_PENDING]: handlePendingLoadPopularArticles,
};

export default createReducer(handlers, initialState);
